import { render, staticRenderFns } from "./results-head.vue?vue&type=template&id=76de4131&"
import script from "./results-head.vue?vue&type=script&lang=js&"
export * from "./results-head.vue?vue&type=script&lang=js&"
import style0 from "./results-head.vue?vue&type=style&index=0&id=76de4131&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports